var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th'):_c('td',{staticClass:"drag-handle-cell"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-handle"},[_c('i',{staticClass:"fa fa-grip-vertical text-muted"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81247ae6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueTableDragHandle.vue
// module id = 1325
// module chunks = 86